<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/template/page"
			getKey="rows" :columns="columns" >
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xieyimubanmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xieyimubandaima')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
					 <el-form-item>
						<el-button @click="yt.get(1)" type="primary"
							plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			 <template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
 			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('mubandianbianji', scope.row,'99%')">
              {{$t('mubandianbianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('shijiandianbianji', scope.row,'70%')">
              {{$t('shijiandianbianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="pointShow = !pointShow,templateId = scope.row.id">
              {{$t('模板点导入')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="eventShow = !eventShow,templateId = scope.row.id">
              {{$t('事件点导入')}}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.isMain == 0">
            <el-button type="text" @click="yt.showEditDialog('tongyongdianyingshe', scope.row);getTemplateIsMain(scope.row.id)">
              {{$t('通用点映射')}}
            </el-button>
          </el-col>
        </el-row>
			</template>
			<!-- 底部插槽 -->
			<!-- <div slot="footer"></div> -->
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xieyimubanmingcheng')" required="required">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xieyimubandaima')" required="required">
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xieyimubanbeizhu')" required="required">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/template/create', null, fetchData)"
						type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('xieyimubanmingcheng')" required="required">
              <el-input disabled v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xieyimubandaima')" required="required">
              <el-input disabled v-model="yt.editObj.code"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xieyimubanbeizhu')" required="required">
              <el-input v-model="yt.editObj.remark"></el-input>
            </el-form-item>
          </el-form>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/template/update')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>

      <!-- 通用点映射 -->
      <template v-if="yt.editObj.action == 'tongyongdianyingshe'">
        <div class="dialog-scroller-form">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
              <el-form-item v-for="(item,index) in mainTemplateList" :label="$t(item.pointI18n)">
                <el-input v-model="mainTemplateList[index].dmCode"></el-input>
              </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/template/point/mapping/updateMappingList',beforeAddMapping)" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>


      <!-- 模板点编辑弹窗 -->
      <template v-if="yt.editObj.action == 'mubandianbianji'">
        <div class="dialog-scroller">
          <template_point :templateId="yt.editObj.id"></template_point>
        </div>
      </template>
      <!-- 事件点编辑弹窗 -->
      <template v-if="yt.editObj.action == 'shijiandianbianji'">
        <div class="dialog-scroller">
          <template_event :templateId="yt.editObj.id"></template_event>
        </div>
      </template>
      <!-- 模板点导入弹窗 -->
      <template v-if="yt.editObj.action == 'mubandiandaoru'">
        <div class="dialog-scroller">
          <point_import_excel :templateId="yt.editObj.id"></point_import_excel>
        </div>
      </template>
		</el-dialog>
    <point_import_excel :show.sync="pointShow" :templateId="templateId"></point_import_excel>
    <event_import_excel :show.sync="eventShow" :templateId="templateId"></event_import_excel>
  </div>
</template>
<script type="text/javascript">
  import point_import_excel from '@@/pages/admin/data_template/protocol/point_import_excel'
  import event_import_excel from '@@/pages/admin/data_template/protocol/event_import_excel'
  import template_point from '@@/pages/admin/data_template/protocol/template_point'
  import template_event from '@@/pages/admin/data_template/protocol/template_event'
  export default {
    components: {
      point_import_excel,
      event_import_excel,
      template_point,
      template_event
    },
		name: 'admin_data_template_protocol_list',

		data() {
			return {
        pointShow: false,
        eventShow: false,
        templateId: null,
        mainTemplateList: [],
				columns: [{
						label: 'xieyimubanmingcheng',
						prop: 'name',
						width: 190
					}, {
            label: 'xieyimubandaima',
            prop: 'code'
          }, {
						label: 'xieyimubanbeizhu',
						prop: 'remark',
						// width: 130
					}, {
          label: 'caozuo',
          type: 'slot',
          width: 500,
          fixed: 'right'
          }
				]
			};
		},
		created() {
			setTimeout(() => {
				/*this.yt.conditions = {
					orderBy:'createTime desc',
				}*/
				this.yt.SELECT_URL = "/web/template/getEquipmentTemplateByIds"
				this.yt.SELECT_RESULT_KEY = "data"
				this.yt.SELECT_ID = "id"
				this.yt.SELECT_TITLE = "name"
				this.yt.get(1);
			}, 300)

		},
		computed: {
			modes() {
				return [{
						label: this.$t("anshujumoban"),
						value: 1
					},
					{
						label: this.$t("anshebei"),
						value: 2
					}
				]
			}
		},
		methods: {
      // 获取主协议
      async getTemplateIsMain(rowId) {
        this.mainTemplateList = []
        let response = await this.http.get('/web/template/point/mapping/listMappingWithAllGeneralPoints', {
          params: {
            templateId: rowId,
          }
        })
        this.mainTemplateList = response.data
        // 固定展现排序
        this.mainTemplateList.sort(function(a, b){
          return a.pointId - b.pointId
        })
      },

      beforeAddMapping(params) {
        params = this.mainTemplateList
        return params
      },
    }
	};
</script>
